import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickTips = () => {
  const tips = [
    {
      icon: "Clock",
      title: "Practice Daily",
      description: "Just 5-10 minutes a day builds lasting skills. Consistency is key to improvement."
    },
    {
      icon: "Mic",
      title: "Be Authentic",
      description: "Use your natural voice. The best responses are genuine, not scripted."
    },
    {
      icon: "RefreshCw",
      title: "Learn from Feedback",
      description: "Review the improved responses to understand what makes them effective."
    },
    {
      icon: "Flame",
      title: "Build Your Streak",
      description: "Track your progress and maintain momentum with daily practice streaks."
    }
  ];

  return (
    <div className="mb-12 px-4">
      <h2 className="text-2xl font-bold text-foreground text-center mb-8">
        Tips for Success
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 max-w-6xl mx-auto">
        {tips?.map((tip, index) => (
          <div
            key={index}
            className="bg-card rounded-xl p-5 border border-border text-center hover:shadow-card transition-all duration-300"
          >
            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
              <Icon name={tip?.icon} size={24} color="var(--color-primary)" />
            </div>
            <h3 className="text-base font-semibold text-foreground mb-2">
              {tip?.title}
            </h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              {tip?.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickTips;